import React, { createContext } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import { MainActions } from '../actions/MainActions';
import { IHttpService } from '../common-services/Http/IHttpService';
import { FakeHttpService } from '../common-services/Http/FakeHttpService';
import { AuthService } from '../common-services/Auth/AuthService';
import { StorageService } from '../common-services/Storage/StorageService';
import { StatesService } from '../services/StatesOrders/StatesService';
import { FilterOrderService } from '../services/Orders/FilterOrder/FilterOrderService';
import { GetUserService } from '../services/Users/GetUser/GetUserService';
import { CreateOrderBatchService } from '../services/OrdersBatches/CreateOrderBatch/CreateOrderBatchService';
import { AddListToOrderBatchService } from '../services/OrdersBatches/AddListToOrderBatch/AddListToOrderBatchService';
import { FilterOrderBatchService } from '../services/OrdersBatches/FilterOrderBatch/FilterOrderBatchService';
import { GetOrderBatchService } from '../services/OrdersBatches/GetOrderBatch/GetOrderBatchService';
import { RemoveListFromOrderBatchService } from '../services/OrdersBatches/RemoveListFromOrderBatch/RemoveListFromOrderBatchService';
import { BatchOrderUserInfoService } from '../services/OrdersBatches/BatchOrderUserInfo/BatchOrderUserInfoService';
import { SaveStateLogService } from '../services/StatesOrders/SaveStateLog/SaveStateLogService';
import { SaveRecipeService } from '../services/Recipes/SaveRecipe/SaveRecipeService';
import { GetRecipesByOrderService } from '../services/Recipes/GetRecipesByOrder/GetRecipesByOrderService';
import { UpdateRecipeService } from '../services/Recipes/UpdateRecipe/UpdateRecipeService';
import { DeleteRecipeService } from '../services/Recipes/DeleteRecipe/DeleteRecipeService';
import { AlertService } from '../common-services/Alert/AlertService';
import { NewOrderRecipeService } from '../services/Files/NewOrderRecipe/NewOrderRecipeService';
import { ToastService } from '../common-services/Toast/ToastService';
import { GetRecipeNotificationsByOrderService } from '../services/RecipesNotifications/GetRecipeNotificationsByOrder/GetRecipeNotificationsByOrderService';
import { SaveRecipeNotificationService } from '../services/RecipesNotifications/SaveRecipeNotification/SaveRecipeNotificationService';
import { ResendRecipeNotificationService } from '../services/RecipesNotifications/ResendRecipeNotification/ResendRecipeNotificationService';
import { StatesPrescriptionsService } from '../services/StatesPrescriptions/StatesPrescriptionsService';
import { SaveStatePrescriptionLogService } from '../services/StatesPrescriptions/SaveStatePrescriptionLog/SaveStatePrescriptionLogService';
import { ReportService } from '../services/Reports/ReportService';
import { GenerateSeparationListReportService } from '../services/Reports/GenerateSeparationListReport/GenerateSeparationListReportService';
import { GenerateShippingGuideReportService } from '../services/Reports/GenerateShippingGuideReport/GenerateShippingGuideReportService';
import { GenerateTSOReportService } from '../services/Reports/GenerateTSOReport/GenerateTSOReportService';
import { GetDanfePackingLabelService } from '../services/Labels/GetDanfePackingLabel/GetDanfePackingLabelService';
import { GetLensCertificateLabelService } from '../services/Labels/GetLensCertificateLabel/GetLensCertificateLabelService';
import { GenerateGroupedGeneralOrdersReportService } from '../services/Reports/GenerateGroupedGeneralOrdersReport/GenerateGroupedGeneralOrdersReportService';
import { CloseOrderBatchService } from '../services/OrdersBatches/CloseOrderBatch/CloseOrderBatchService';
import { GetStateLogByOrderService } from '../services/Orders/GetStateLogByOrder/GetStateLogByOrderService';
import { GetHistoryByOrderService } from '../services/Orders/GetHistoryByOrder/GetHistoryByOrderService';
import { GetCurrentStatesByOrdersService } from '../services/Orders/GetCurrentStatesByOrders/GetCurrentStatesByOrdersService';
import { OrderForListingService } from '../services/Orders/OrderForListingService';
import { GetSimplePackingLabelService } from '../services/Labels/GetSimplePackingLabel/GetSimplePackingLabelService';
import { GetOrderStatesCountService } from '../services/Orders/GetOrderStatesCount/GetOrderStatesCountService';
import { GetCollectTrackingByOrderService } from '../services/Orders/GetCollectTrackingByOrder/GetCollectTrackingByOrderService';
import { GetInternalCommunicationByOrderService } from '../services/InternalCommunications/GetInternalCommunicationByOrder/GetInternalCommunicationByOrderService';
import { AddInternalCommunicationService } from '../services/InternalCommunications/AddInternalCommunication/AddInternalCommunicationService';
import { SaveOrderLogService } from '../services/OrderLogs/SaveOrderLog/SaveOrderLogService';
import { GetOrdersInTransportService } from '../services/Orders/GetOrdersInTransport/GetOrdersInTransportService';
import { GetErpNfService } from '../services/ErpIntegrations/GetErpNf/GetErpNfService';
import { GetErpOrderNFeService } from '../services/Orders/GetErpOrderNFe/GetErpOrderNFeService';
import { GetUpdatedErpOrderService } from '../services/Orders/GetUpdatedErpOrder/GetUpdatedErpOrderService';
import { ConsultTrackingOrderService } from '../services/Carriers/ConsultTrackingOrder/ConsultTrackingOrderService';
import { GetListOfValidDnpLinkService } from '../services/DnpLinks/GetListOfValidDnpLink/GetListOfValidDnpLinkService';
import { GetNewDnpLinkService } from '../services/DnpLinks/GetNewDnpLink/GetNewDnpLinkService';
import { GetOrderDetailsService } from '../services/Orders/GetOrderDetails/GetOrderDetailsService';
import { GetFrameBySkuService } from '../services/Frames/GetFrameBySku/GetFrameBySkuService';
import { GetFramesByOrderService } from '../services/Orders/GetFramesByOrder/GetFramesByOrderService';
import { GetOrderNotesByOrderService } from '../services/Orders/GetOrderNotesByOrder/GetOrderNotesByOrderService';
import { SaveOrderNoteService } from '../services/OrderNotes/SaveOrderNote/SaveOrderNoteService';
import { GetSellersService } from '../services/Sellers/GetSellers/GetSellersService';
import { FilterCustomerService } from '../services/Customers/FilterCustomer/FilterCustomerService';
import { GetCustomerByIdService } from '../services/Customers/GetCustomerById/GetCustomerByIdService';
import { GetAddressesByZipService } from '../services/Addresses/GetAddressesByZip/GetAddressesByZipService';
import { NewCustomerService } from '../services/Customers/NewCustomer/NewCustomerService';
import { SaveCustomerNoteService } from '../services/CustomerNotes/SaveCustomerNote/SaveCustomerNoteService';
import { GetCustomerNotesByCustomerService } from '../services/Customers/GetCustomerNotesByCustomer/GetCustomerNotesByCustomerService';
import { UpdateOrderItemFulfillmentService } from '../services/Orders/UpdateOrderItemFulfillment/UpdateOrderItemFulfillmentService';
import { UpdateCustomerService } from '../services/Customers/UpdateCustomer/UpdateCustomerService';
import { ChangeOrderCustomerService } from '../services/Orders/ChangeOrderCustomer/ChangeOrderCustomerService';
import { NewLooseCustomerRecipeService } from '../services/CustomerRecipes/NewLooseCustomerRecipe/NewLooseCustomerRecipeService';
import { GetCustomerRecipeHistoryByIdService } from '../services/Customers/GetCustomerRecipeHistoryById/GetCustomerRecipeHistoryByIdService';
import { DeleteLooseCustomerRecipeService } from '../services/CustomerRecipes/DeleteLooseCustomerRecipe/DeleteLooseCustomerRecipeService';
import { UpdateLooseCustomerRecipeService } from '../services/CustomerRecipes/UpdateLooseCustomerRecipe/UpdateLooseCustomerRecipeService';
import { GetPairsFrameLensByOrderService } from '../services/RecipeByProducts/GetPairsFrameLensByOrder/GetPairsFrameLensByOrderService';
import { GetOrderLinkingRequestsService } from '../services/RecipeByProducts/GetOrderLinkingRequests/GetOrderLinkingRequestsService';
import { SaveProductRecipeLinkingRequestService } from '../services/RecipeByProducts/SaveProductRecipeLinkingRequest/SaveProductRecipeLinkingRequestService';
import { GetOrderRecipesAndLinkedCustomerRecipesService } from '../services/Orders/GetOrderRecipesAndLinkedCustomerRecipes/GetOrderRecipesAndLinkedCustomerRecipesService';
import { GetDetailedStatusForOrderRecipeLinkingService } from '../services/RecipeByProducts/GetDetailedStatusForOrderRecipeLinking/GetDetailedStatusForOrderRecipeLinkingService';
import { RequestLensesService } from '../services/Orders/RequestLenses/RequestLensesService';
import { CheckIfRecipeIsLockedService } from '../services/CustomerRecipes/CheckIfRecipeIsLocked/CheckIfRecipeIsLockedService';
import { GetShippingLinesByOrderService } from '../services/Orders/GetShippingLinesByOrder/GetShippingLinesByOrderService';
import { GetErpOrdersByOrderService } from '../services/Orders/GetErpOrdersByOrder/GetErpOrdersByOrderService';
import { SetShippingLineOrderService } from '../services/Orders/SetShippingLineOrder/SetShippingLineOrderService';
import { GetOrderAddressesService } from '../services/Orders/GetOrderAddresses/GetOrderAddressesService';
import { RecollectOrderService } from '../services/Orders/RecollectOrder/RecollectOrderService';
import { GetCountNotificationsByOrdersService } from '../services/RecipesNotifications/GetCountNotificationsByOrders/GetCountNotificationsByOrdersService';
import { GetOrderIdsForGroupedGeneralReportService } from '../services/Reports/GetOrderIdsForGroupedGeneralReport/GetOrderIdsForGroupedGeneralReportService';
import { GetOrderIdListForTransportOrderBaseReportService } from '../services/Reports/GetOrderIdListForTransportOrderBaseReport/GetOrderIdListForTransportOrderBaseReportService';
import { GenerateTransportOrderBaseReportService } from '../services/Reports/GenerateTransportOrderBaseReport/GenerateTransportOrderBaseReportService';
import { LinkRecipeWithCustomerRecipeService } from '../services/Recipes/LinkRecipeWithCustomerRecipe/LinkRecipeWithCustomerRecipeService';
import { GenerateTransferredItemsSeparationListReportService } from '../services/Reports/GenerateTransferredItemsSeparationListReport/GenerateTransferredItemsSeparationListReportService';
import { UpdateOrderWithFullCoverageInCentralStockService } from '../services/Orders/UpdateOrderWithFullCoverageInCentralStock/UpdateOrderWithFullCoverageInCentralStockService';
import { ReopenClosedOrderService } from '../services/Orders/ReopenClosedOrder/ReopenClosedOrderService';
import { FileRepository } from '../services/FileRepository/FileRepository';
import { SaveOrderImportService } from '../services/Marketplaces/SaveOrderImport/SaveOrderImportService';
import { GetOrderImportsService } from '../services/Marketplaces/GetOrderImports/GetOrderImportsService';
import { GetOrderImportService } from '../services/Marketplaces/GetOrderImport/GetOrderImportService';
import { GetAssemblerOrderDetailsByOrderService } from '../services/Orders/GetAssemblerOrderDetailsByOrder/GetAssemblerOrderDetailsByOrderService';
import { UpdateOrderAssemblyStateService } from '../services/Orders/UpdateOrderAssemblyState/UpdateOrderAssemblyStateService';
import { GetRecipeCollectionNotificationsByOrderService } from '../services/RecipesNotifications/GetRecipeCollectionNotificationsByOrder/GetRecipeCollectionNotificationsByOrderService';
import { GenerateInternalCommunicationsToCollectRecipeByOrderService } from '../services/InternalCommunications/GenerateInternalCommunicationsToCollectRecipeByOrder/GenerateInternalCommunicationsToCollectRecipeByOrderService';
import { GenerateLensSeparationListReportService } from '../services/Reports/GenerateLensSeparationListReport/GenerateLensSeparationListReportService';
import { GetProductGroupingsByOrderService } from '../services/ProductGroups/GetProductGroupingsByOrder/GetProductGroupingsByOrderService';
import { GetOrderItemsByOrderService } from '../services/Orders/GetOrderItemsByOrder/GetOrderItemsByOrderService';
import { CreateProductGroupingService } from '../services/ProductGroups/CreateProductGrouping/CreateProductGroupingService';
import { AddProductGroupingService } from '../services/ProductGroups/AddProductGrouping/AddProductGroupingService';
import { RemoveProductGroupingService } from '../services/ProductGroups/RemoveProductGrouping/RemoveProductGroupingService';
import { GetOrderSummaryForProductGroupingService } from '../services/ProductGroups/GetOrderSummaryForProductGrouping/GetOrderSummaryForProductGroupingService';
import { RemoveProductRecipeLinkingRequestService } from '../services/RecipeByProducts/RemoveProductRecipeLinkingRequest/RemoveProductRecipeLinkingRequestService';
import { GetAllFrontVersionsService } from '../services/FrontVersions/GetAllFrontVersions/GetAllFrontVersionsService';
import { ChangeTrackingCodeService } from '../services/CollectTrackings/ChangeTrackingCode/ChangeTrackingCodeService';
import { GetLocationListService } from '../services/Locations/GetLocationList/GetLocationListService';
import { GetCarrierListService } from '../services/Carriers/GetCarrierList/GetCarrierListService';
import { GetCarrierStatusTrackingListService } from '../services/Carriers/GetCarrierStatusTrackingList/GetCarrierStatusTrackingListService';
import { RegisterAssemblyDisapprovalByOrderService } from '../services/Orders/RegisterAssemblyDisapprovalByOrder/RegisterAssemblyDisapprovalByOrderService';
import { GetActiveSellersByLocationsService } from '../services/Sellers/GetActiveSellersByLocations/GetActiveSellersByLocationsService';
import { GetFulfillmentsByOrderService } from '../services/Orders/GetFulfillmentsByOrder/GetFulfillmentsByOrderService';
import { GetDigitalCertificatePageLinkService } from '../services/Orders/GetDigitalCertificatePageLink/GetDigitalCertificatePageLinkService';
import { GetAppConfigListService } from '../services/AppConfigs/GetAppConfigList/GetAppConfigListService';
import { UpdateAppConfigValueService } from '../services/AppConfigs/UpdateAppConfigValue/UpdateAppConfigValueService';
import { RequestProcessPrescriptionStateService } from '../services/Orders/RequestProcessPrescriptionState/RequestProcessPrescriptionStateService';
import { GetLensCuttingMachineIntegrationFileByOrderService } from '../services/LensCuttingMachineIntegrations/GetLensCuttingMachineIntegrationFileByOrder/GetLensCuttingMachineIntegrationFileByOrderService';
import { GenerateLensCuttingMachineIntegrationFileService } from '../services/LensCuttingMachineIntegrations/GenerateLensCuttingMachineIntegrationFile/GenerateLensCuttingMachineIntegrationFileSevice';
import { GetDanfeLabelPreGenerationInfoService } from '../services/Labels/GetDanfeLabelPreGenerationInfo/GetDanfeLabelPreGenerationInfoService';
import { GetCarrierDanfeLabelByOrdersService } from '../services/Labels/GetCarrierDanfeLabelByOrders/GetCarrierDanfeLabelByOrdersService';
import { GetAppConfigByFieldService } from '../services/AppConfigs/GetAppConfigByField/GetAppConfigByFieldService';

export interface IServices {
  httpService: IHttpService;
  authService: AuthService;
  storageService: StorageService;
  reportService: ReportService;
  statesService: StatesService;
  filterOrderService: FilterOrderService;
  getUserService: GetUserService;
  createOrderBatchService: CreateOrderBatchService;
  addListToOrderBatchService: AddListToOrderBatchService;
  filterOrderBatchService: FilterOrderBatchService;
  getOrderBatchService: GetOrderBatchService;
  removeListFromOrderBatchService: RemoveListFromOrderBatchService;
  batchOrderUserInfoService: BatchOrderUserInfoService;
  saveStateLogService: SaveStateLogService;
  saveRecipeService: SaveRecipeService;
  getRecipesByOrderService: GetRecipesByOrderService;
  updateRecipeService: UpdateRecipeService;
  deleteRecipeService: DeleteRecipeService;
  alertService: AlertService;
  newOrderRecipeService: NewOrderRecipeService;
  toastService: ToastService;
  getRecipeNotificationsByOrderService: GetRecipeNotificationsByOrderService;
  saveRecipeNotificationService: SaveRecipeNotificationService;
  resendRecipeNotificationService: ResendRecipeNotificationService;
  statesPrescriptionsService: StatesPrescriptionsService;
  saveStatePrescriptionLogService: SaveStatePrescriptionLogService;
  generateSeparationListReportService: GenerateSeparationListReportService;
  generateShippingGuideReportService: GenerateShippingGuideReportService;
  generateTSOReportService: GenerateTSOReportService;
  getDanfePackingLabelService: GetDanfePackingLabelService;
  getLensCertificateLabelService: GetLensCertificateLabelService;
  generateGroupedGeneralOrdersReportService: GenerateGroupedGeneralOrdersReportService;
  closeOrderBatchService: CloseOrderBatchService;
  getStateLogByOrderService: GetStateLogByOrderService;
  getHistoryByOrderService: GetHistoryByOrderService;
  getCurrentStatesByOrdersService: GetCurrentStatesByOrdersService;
  orderForListingService: OrderForListingService;
  getSimplePackingLabelService: GetSimplePackingLabelService;
  getAlertSummaryService: GetOrderStatesCountService;
  getCollectTrackingByOrderService: GetCollectTrackingByOrderService;
  getInternalCommunicationByOrderService: GetInternalCommunicationByOrderService;
  addInternalCommunicationService: AddInternalCommunicationService;
  saveOrderLogService: SaveOrderLogService;
  getOrdersInTransportService: GetOrdersInTransportService;
  getErpNfService: GetErpNfService;
  getErpOrderNFeService: GetErpOrderNFeService;
  getUpdatedErpOrderService: GetUpdatedErpOrderService;
  consultTrackingOrderService: ConsultTrackingOrderService;
  getListOfValidDnpLinkService: GetListOfValidDnpLinkService;
  getNewDnpLinkService: GetNewDnpLinkService;
  getOrderDetailsService: GetOrderDetailsService;
  getFrameBySkuService: GetFrameBySkuService;
  getFramesByOrderService: GetFramesByOrderService;
  getOrderNotesByOrderService: GetOrderNotesByOrderService;
  saveOrderNoteService: SaveOrderNoteService;
  getSellersService: GetSellersService;
  filterCustomerService: FilterCustomerService;
  getCustomerByIdService: GetCustomerByIdService;
  getAddressesByZipService: GetAddressesByZipService;
  newCustomerService: NewCustomerService;
  saveCustomerNoteService: SaveCustomerNoteService;
  getCustomerNotesByCustomerService: GetCustomerNotesByCustomerService;
  updateOrderItemFulfillmentService: UpdateOrderItemFulfillmentService;
  updateCustomerService: UpdateCustomerService;
  changeOrderCustomerService: ChangeOrderCustomerService;
  newLooseCustomerRecipeService: NewLooseCustomerRecipeService;
  getCustomerRecipeHistoryByIdService: GetCustomerRecipeHistoryByIdService;
  deleteLooseCustomerRecipeService: DeleteLooseCustomerRecipeService;
  updateLooseCustomerRecipeService: UpdateLooseCustomerRecipeService;
  getPairsFrameLensByOrderService: GetPairsFrameLensByOrderService;
  getOrderLinkingRequestsService: GetOrderLinkingRequestsService;
  saveProductRecipeLinkingRequestService: SaveProductRecipeLinkingRequestService;
  getOrderRecipesAndLinkedCustomerRecipesService: GetOrderRecipesAndLinkedCustomerRecipesService;
  getDetailedStatusForOrderRecipeLinkingService: GetDetailedStatusForOrderRecipeLinkingService;
  requestLensesService: RequestLensesService;
  checkIfRecipeIsLockedService: CheckIfRecipeIsLockedService;
  getShippingLinesByOrderService: GetShippingLinesByOrderService;
  getErpOrdersByOrderService: GetErpOrdersByOrderService;
  setShippingLineOrderService: SetShippingLineOrderService;
  getOrderAddressesService: GetOrderAddressesService;
  recollectOrderService: RecollectOrderService;
  getCountNotificationsByOrdersService: GetCountNotificationsByOrdersService;
  getOrderIdsForGroupedGeneralReportService: GetOrderIdsForGroupedGeneralReportService;
  getOrderIdListForTransportOrderBaseReportService: GetOrderIdListForTransportOrderBaseReportService;
  generateTransportOrderBaseReportService: GenerateTransportOrderBaseReportService;
  linkRecipeWithCustomerRecipeService: LinkRecipeWithCustomerRecipeService;
  generateTransferredItemsSeparationListReportService: GenerateTransferredItemsSeparationListReportService;
  updateOrderWithFullCoverageInCentralStockService: UpdateOrderWithFullCoverageInCentralStockService;
  reopenClosedOrderService: ReopenClosedOrderService;
  fileRepository: FileRepository;
  saveOrderImportService: SaveOrderImportService;
  getOrderImportsService: GetOrderImportsService;
  getOrderImportService: GetOrderImportService;
  getAssemblerOrderDetailsByOrderService: GetAssemblerOrderDetailsByOrderService;
  updateOrderAssemblyStateService: UpdateOrderAssemblyStateService;
  getRecipeCollectionNotificationsByOrderService: GetRecipeCollectionNotificationsByOrderService;
  generateInternalCommunicationsToCollectRecipeByOrderService: GenerateInternalCommunicationsToCollectRecipeByOrderService;
  generateLensSeparationListReportService: GenerateLensSeparationListReportService;
  getProductGroupingsByOrderService: GetProductGroupingsByOrderService;
  getOrderItemsByOrderService: GetOrderItemsByOrderService;
  createProductGroupingService: CreateProductGroupingService;
  addProductGroupingService: AddProductGroupingService;
  removeProductGroupingService: RemoveProductGroupingService;
  getOrderSummaryForProductGroupingService: GetOrderSummaryForProductGroupingService;
  removeProductRecipeLinkingRequestService: RemoveProductRecipeLinkingRequestService;
  getAllFrontVersionsService: GetAllFrontVersionsService;
  changeTrackingCodeService: ChangeTrackingCodeService;
  getLocationListService: GetLocationListService;
  getCarrierListService: GetCarrierListService;
  getCarrierStatusTrackingListService: GetCarrierStatusTrackingListService;
  registerAssemblyDisapprovalByOrderService: RegisterAssemblyDisapprovalByOrderService;
  getActiveSellersByLocationsService: GetActiveSellersByLocationsService;
  getFulfillmentsByOrderService: GetFulfillmentsByOrderService;
  getDigitalCertificatePageLinkService: GetDigitalCertificatePageLinkService;
  getAppConfigListService: GetAppConfigListService;
  updateAppConfigValueService: UpdateAppConfigValueService;
  requestProcessPrescriptionStateService: RequestProcessPrescriptionStateService;
  getLensCuttingMachineIntegrationFileByOrderService: GetLensCuttingMachineIntegrationFileByOrderService;
  generateLensCuttingMachineIntegrationFileService: GenerateLensCuttingMachineIntegrationFileService;
  getDanfeLabelPreGenerationInfoService: GetDanfeLabelPreGenerationInfoService;
  getCarrierDanfeLabelByOrdersService: GetCarrierDanfeLabelByOrdersService;
  getAppConfigByFieldService: GetAppConfigByFieldService;
  //other services...
}

export const createServices = (httpService?: IHttpService): IServices => {

  httpService = httpService || new FakeHttpService();

  const getUserService = new GetUserService(httpService);
  const statesService = new StatesService();
  const statesPrescriptionsService = new StatesPrescriptionsService();
  const reportService = new ReportService();
  const toastService = new ToastService();
  const alertService = new AlertService();
  const getCurrentStatesByOrdersService = new GetCurrentStatesByOrdersService(httpService);
  const getCountNotificationsByOrdersService = new GetCountNotificationsByOrdersService(httpService);

  const states = statesService.get();
  const deliveryStates = statesService.getDelivery();
  const statesPrescription = statesPrescriptionsService.get();

  const fileRepository = new FileRepository(httpService);

  const orderForListingService = new OrderForListingService(
    alertService,
    getCurrentStatesByOrdersService,
    states,
    deliveryStates,
    statesPrescription,
    getCountNotificationsByOrdersService
  );

  return {
    httpService: httpService,
    authService: new AuthService(getUserService, httpService),
    storageService: new StorageService(),
    reportService: reportService,
    alertService: new AlertService(),
    statesService: statesService,
    filterOrderService: new FilterOrderService(orderForListingService, httpService),
    getUserService: getUserService,
    createOrderBatchService: new CreateOrderBatchService(httpService),
    addListToOrderBatchService: new AddListToOrderBatchService(httpService),
    filterOrderBatchService: new FilterOrderBatchService(httpService),
    getOrderBatchService: new GetOrderBatchService(httpService),
    removeListFromOrderBatchService: new RemoveListFromOrderBatchService(httpService),
    batchOrderUserInfoService: new BatchOrderUserInfoService(httpService),
    saveStateLogService: new SaveStateLogService(httpService),
    saveRecipeService: new SaveRecipeService(httpService),
    getRecipesByOrderService: new GetRecipesByOrderService(httpService),
    updateRecipeService: new UpdateRecipeService(httpService),
    deleteRecipeService: new DeleteRecipeService(httpService),
    newOrderRecipeService: new NewOrderRecipeService(httpService),
    toastService: toastService,
    getRecipeNotificationsByOrderService: new GetRecipeNotificationsByOrderService(),
    saveRecipeNotificationService: new SaveRecipeNotificationService(),
    resendRecipeNotificationService: new ResendRecipeNotificationService(),
    statesPrescriptionsService: statesPrescriptionsService,
    saveStatePrescriptionLogService: new SaveStatePrescriptionLogService(httpService),
    generateSeparationListReportService: new GenerateSeparationListReportService(reportService, toastService, httpService),
    generateShippingGuideReportService: new GenerateShippingGuideReportService(reportService, toastService, httpService),
    generateTSOReportService: new GenerateTSOReportService(reportService, toastService, httpService),
    getDanfePackingLabelService: new GetDanfePackingLabelService(reportService, toastService, httpService),
    getLensCertificateLabelService: new GetLensCertificateLabelService(reportService, toastService, httpService),
    generateGroupedGeneralOrdersReportService: new GenerateGroupedGeneralOrdersReportService(reportService, toastService, httpService),
    closeOrderBatchService: new CloseOrderBatchService(httpService),
    getStateLogByOrderService: new GetStateLogByOrderService(httpService),
    getHistoryByOrderService: new GetHistoryByOrderService(httpService),
    getCurrentStatesByOrdersService: getCurrentStatesByOrdersService,
    orderForListingService: orderForListingService,
    getSimplePackingLabelService: new GetSimplePackingLabelService(reportService, toastService, httpService),
    getAlertSummaryService: new GetOrderStatesCountService(httpService),
    getCollectTrackingByOrderService: new GetCollectTrackingByOrderService(httpService),
    getInternalCommunicationByOrderService: new GetInternalCommunicationByOrderService(httpService),
    addInternalCommunicationService: new AddInternalCommunicationService(httpService),
    saveOrderLogService: new SaveOrderLogService(httpService),
    getOrdersInTransportService: new GetOrdersInTransportService(httpService),
    getErpNfService: new GetErpNfService(httpService),
    getErpOrderNFeService: new GetErpOrderNFeService(httpService),
    getUpdatedErpOrderService: new GetUpdatedErpOrderService(httpService),
    consultTrackingOrderService: new ConsultTrackingOrderService(httpService),
    getListOfValidDnpLinkService: new GetListOfValidDnpLinkService(httpService),
    getNewDnpLinkService: new GetNewDnpLinkService(httpService),
    getOrderDetailsService: new GetOrderDetailsService(httpService),
    getFrameBySkuService: new GetFrameBySkuService(httpService),
    getFramesByOrderService: new GetFramesByOrderService(httpService),
    getOrderNotesByOrderService: new GetOrderNotesByOrderService(httpService),
    saveOrderNoteService: new SaveOrderNoteService(httpService),
    getSellersService: new GetSellersService(httpService),
    filterCustomerService: new FilterCustomerService(httpService),
    getCustomerByIdService: new GetCustomerByIdService(httpService),
    getAddressesByZipService: new GetAddressesByZipService(httpService),
    newCustomerService: new NewCustomerService(httpService),
    saveCustomerNoteService: new SaveCustomerNoteService(httpService),
    getCustomerNotesByCustomerService: new GetCustomerNotesByCustomerService(httpService),
    updateOrderItemFulfillmentService: new UpdateOrderItemFulfillmentService(httpService),
    updateCustomerService: new UpdateCustomerService(httpService),
    changeOrderCustomerService: new ChangeOrderCustomerService(httpService),
    newLooseCustomerRecipeService: new NewLooseCustomerRecipeService(httpService),
    getCustomerRecipeHistoryByIdService: new GetCustomerRecipeHistoryByIdService(httpService),
    deleteLooseCustomerRecipeService: new DeleteLooseCustomerRecipeService(httpService),
    updateLooseCustomerRecipeService: new UpdateLooseCustomerRecipeService(httpService),
    getPairsFrameLensByOrderService: new GetPairsFrameLensByOrderService(httpService),
    getOrderLinkingRequestsService: new GetOrderLinkingRequestsService(httpService),
    saveProductRecipeLinkingRequestService: new SaveProductRecipeLinkingRequestService(httpService),
    getOrderRecipesAndLinkedCustomerRecipesService: new GetOrderRecipesAndLinkedCustomerRecipesService(httpService),
    getDetailedStatusForOrderRecipeLinkingService: new GetDetailedStatusForOrderRecipeLinkingService(httpService),
    requestLensesService: new RequestLensesService(httpService),
    checkIfRecipeIsLockedService: new CheckIfRecipeIsLockedService(httpService),
    getShippingLinesByOrderService: new GetShippingLinesByOrderService(httpService),
    getErpOrdersByOrderService: new GetErpOrdersByOrderService(httpService),
    setShippingLineOrderService: new SetShippingLineOrderService(httpService),
    getOrderAddressesService: new GetOrderAddressesService(httpService),
    recollectOrderService: new RecollectOrderService(httpService),
    getCountNotificationsByOrdersService: getCountNotificationsByOrdersService,
    getOrderIdsForGroupedGeneralReportService: new GetOrderIdsForGroupedGeneralReportService(httpService),
    getOrderIdListForTransportOrderBaseReportService: new GetOrderIdListForTransportOrderBaseReportService(httpService),
    generateTransportOrderBaseReportService: new GenerateTransportOrderBaseReportService(reportService, toastService, httpService),
    linkRecipeWithCustomerRecipeService: new LinkRecipeWithCustomerRecipeService(httpService),
    generateTransferredItemsSeparationListReportService: new GenerateTransferredItemsSeparationListReportService(reportService, toastService, httpService),
    updateOrderWithFullCoverageInCentralStockService: new UpdateOrderWithFullCoverageInCentralStockService(httpService),
    reopenClosedOrderService: new ReopenClosedOrderService(httpService),
    fileRepository: fileRepository,
    saveOrderImportService: new SaveOrderImportService(httpService),
    getOrderImportsService: new GetOrderImportsService(httpService),
    getOrderImportService: new GetOrderImportService(httpService),
    getAssemblerOrderDetailsByOrderService: new GetAssemblerOrderDetailsByOrderService(httpService),
    updateOrderAssemblyStateService: new UpdateOrderAssemblyStateService(httpService),
    getRecipeCollectionNotificationsByOrderService: new GetRecipeCollectionNotificationsByOrderService(httpService),
    generateInternalCommunicationsToCollectRecipeByOrderService: new GenerateInternalCommunicationsToCollectRecipeByOrderService(httpService),
    generateLensSeparationListReportService: new GenerateLensSeparationListReportService(reportService, toastService, httpService),
    getProductGroupingsByOrderService: new GetProductGroupingsByOrderService(httpService),
    getOrderItemsByOrderService: new GetOrderItemsByOrderService(httpService),
    createProductGroupingService: new CreateProductGroupingService(httpService),
    addProductGroupingService: new AddProductGroupingService(httpService),
    removeProductGroupingService: new RemoveProductGroupingService(httpService),
    getOrderSummaryForProductGroupingService: new GetOrderSummaryForProductGroupingService(httpService),
    removeProductRecipeLinkingRequestService: new RemoveProductRecipeLinkingRequestService(httpService),
    getAllFrontVersionsService: new GetAllFrontVersionsService(httpService),
    changeTrackingCodeService: new ChangeTrackingCodeService(httpService),
    getLocationListService: new GetLocationListService(httpService),
    getCarrierListService: new GetCarrierListService(httpService),
    getCarrierStatusTrackingListService: new GetCarrierStatusTrackingListService(httpService),
    registerAssemblyDisapprovalByOrderService: new RegisterAssemblyDisapprovalByOrderService(httpService),
    getActiveSellersByLocationsService: new GetActiveSellersByLocationsService(httpService),
    getFulfillmentsByOrderService: new GetFulfillmentsByOrderService(httpService),
    getDigitalCertificatePageLinkService: new GetDigitalCertificatePageLinkService(httpService),
    getAppConfigListService: new GetAppConfigListService(httpService),
    updateAppConfigValueService: new UpdateAppConfigValueService(httpService),
    requestProcessPrescriptionStateService: new RequestProcessPrescriptionStateService(httpService),
    getLensCuttingMachineIntegrationFileByOrderService: new GetLensCuttingMachineIntegrationFileByOrderService(httpService),
    generateLensCuttingMachineIntegrationFileService: new GenerateLensCuttingMachineIntegrationFileService(httpService),
    getDanfeLabelPreGenerationInfoService: new GetDanfeLabelPreGenerationInfoService(httpService),
    getCarrierDanfeLabelByOrdersService: new GetCarrierDanfeLabelByOrdersService(httpService),
    getAppConfigByFieldService: new GetAppConfigByFieldService(httpService),
    //other services...
  }
}

const defaultValue = createServices();

const ServicesContext = createContext<IServices>(defaultValue);

interface IServicesProviderProps {
  httpService?: IHttpService;
}

const ServicesProvider: React.FC<IServicesProviderProps> = ({
  children,
  httpService
}) => {

  const dispatch = useDispatch();
  const mainActions = React.useMemo(() => new MainActions(dispatch), [dispatch])

  construct();

  const value = createServices(httpService);

  return (
    <ServicesContext.Provider value={value}>
      {children}
    </ServicesContext.Provider>
  );

  function construct() {
    axios.interceptors.request.use(function (config) {
      mainActions.setWaiting(true);
      return config;
    }, function (error) {
      setTimeout(() => mainActions.setWaiting(false), 500);
      return Promise.reject(error);
    });

    axios.interceptors.response.use(function (response) {
      setTimeout(() => mainActions.setWaiting(false), 500);
      return response;
    }, function (error) {
      setTimeout(() => mainActions.setWaiting(false), 500);
      return Promise.reject(error);
    });
  }
}

export { ServicesProvider };
export default ServicesContext;